import { Link, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { RunTranscript } from '@/components/runs/RunTranscript';

/** One run's live transcript. Polling and rendering live in RunTranscript;
 * this page provides the frame and swaps the URL when "Run again" fires. */
export function RunDetailPage() {
  const { runId } = useParams<{ runId: string }>();
  const navigate = useNavigate();

  if (!runId) return null;

  return (
    <div className="max-w-3xl">
      <Link to=".." relative="path" className="mb-4 inline-flex items-center gap-1.5 text-sm text-fg-muted hover:text-fg">
        <ArrowLeft className="h-4 w-4" /> All runs
      </Link>
      <RunTranscript runId={runId} onRetryStarted={(newRunId) => navigate(`../${newRunId}`, { relative: 'path' })} />
    </div>
  );
}
